module.exports = __webpack_public_path__ + "assets/img/teacher (2).326a5d8a.png";